const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAirConditioner = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 2687.27 877.52",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M2687.27,124V753.58a124,124,0,0,1-124,123.94H124A124,124,0,0,1,0,753.58V124A124,124,0,0,1,124,0H2563.31a124,124,0,0,1,124,124",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M2580.89,468H2192.38V346.15h388.51V468",
    style: {
      fill: "#c6c6c5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M2566.07,358.08v98h-358.9v-98h358.9",
    style: {
      fill: "#6d8693"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M2329.46,456h-91.34l86.73-98h91.32l-86.71,98",
    style: {
      fill: "#7c929e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M2478,456h-91.32l86.73-97.94h91.32L2478,456",
    style: {
      fill: "#7c929e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M106.4,566.58,41.74,706.23H2645.55l-64.66-139.65H106.4",
    style: {
      fill: "#ececec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M2580.89,673.32H106.41V634.41H2580.89v38.91",
    style: {
      fill: "#6d8693"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M2687.27,542.66H0v-12H2687.27v12",
    style: {
      fill: "#c6c6c5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M2687.27,137.67H0v-12H2687.27v12",
    style: {
      fill: "#c6c6c5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M106.4,566.58,41.74,631.27H2645.55l-64.66-64.69H106.4",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M106.4,676.47,41.74,845.4H2645.55l-64.66-168.93H106.4",
    style: {
      fill: "#ececec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M898.46,803.48H106.41V744.3H898.46v59.18",
    style: {
      fill: "#6d8693"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M1739.68,803.48H947.63V744.3h792.05v59.18",
    style: {
      fill: "#6d8693"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M2580.89,803.49h-792V744.3h792.05v59.19",
    style: {
      fill: "#6d8693"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M106.4,676.47,41.74,743.63H2645.55l-64.66-67.16H106.4",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M2687.27,124v1.73H0V124A124,124,0,0,1,124,0H2563.31a124,124,0,0,1,124,124",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M195.56,464.58a24.24,24.24,0,1,1-24.24-24.24,24.24,24.24,0,0,1,24.24,24.24",
    style: {
      fill: "#c6c6c5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M190.42,464.57a19.11,19.11,0,1,1-19.1-19.1,19.12,19.12,0,0,1,19.1,19.1",
    style: {
      fill: "#35a8e0"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAirConditioner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/air-conditioner.f6455ce600e93722e599e07a3929d7ee.svg";